<!--
 * @Author: mazhigang
 * @Date: 2023-07-03 17:43:22
 * @LastEditors: mazhigang
 * @LastEditTime: 2024-01-31 13:15:14
-->
<template>
  <div class="content">
    <system :leftList="leftList"></system>
    <div class="pageBox">
      <div class="breadcrumb">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>白名单</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="pageSerch">
        <el-card class="box-card" shadow="never">
          <div slot="header" class="clearfix">
            <span class="cardTitle">白名单</span>
          </div>
          <el-form ref="ruleForm" :model="ruleForm">
            <el-row :gutter="24">
              <el-col :span="8">
                <el-form-item>
                  <el-input
                    maxlength="50"
                    v-model="ruleForm.name"
                    placeholder="请输入账号"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item>
                  <el-button type="primary" @click="getList()" class="btn"
                    >查询</el-button
                  >
                  <el-button @click="resetForm()">重置</el-button>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </el-card>
      </div>
      <div class="pageTab">
        <div
          style="
            display: flex;
            justify-content: space-between;
            align-items: center;
          "
        >
          <div style="display: flex; align-items: center">
            <div
              style="margin-right: 10px"
              :class="['pageTitle1', active == 0 ? 'active' : '']"
              @click="selectTab(0)"
            >
              保安白名单
            </div>
            <div
              :class="['pageTitle1', active == 1 ? 'active' : '']"
              @click="selectTab(1)"
            >
              客户白名单
            </div>
          </div>
          <el-button
            type="primary"
            class="btn"
            style="margin-bottom: 16px"
            @click="add()"
            >添加</el-button
          >
        </div>

        <el-table :data="tableData" style="width: 100%">
          <el-table-column prop="id" label="编号" align="center">
          </el-table-column>
          <el-table-column prop="propValue" label="账号" align="center">
          </el-table-column>
          <el-table-column label="排序" align="center" prop="sort">
          </el-table-column>
          <el-table-column
            prop="gmtCreate"
            label="创建时间"
            align="center"
            width="180"
          >
          </el-table-column>

          <el-table-column label="操作" align="center" width="180">
            <template slot-scope="scope">
              <div class="disAround">
                <div class="operateBtn" @click="handleEdit(scope.row)">
                  编辑
                </div>
                <div
                  class="operateBtn redColor1"
                  @click="deleteItem(scope.row)"
                >
                  删除
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-sizes="[10, 20, 30, 50]"
          :page-size="pageSize"
          layout="total, prev, pager, next,sizes"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
    <el-dialog :title="title" :visible.sync="dialogFormVisible" width="600px">
      <el-form
        label-position="right"
        :model="ruleForm1"
        :rules="rules"
        ref="ruleForm"
        style="margin: 0 auto"
      >
        <el-form-item label="手机号" prop="name">
          <el-input
            v-model="ruleForm1.name"
            maxlength="11"
            placeholder="请输入手机号"
          ></el-input>
        </el-form-item>
        <el-form-item label="排序" prop="sort">
          <el-input
            v-model="ruleForm1.sort"
            maxlength="50"
            placeholder="请输入排序"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button @click="resetForm1('ruleForm')">取消</el-button>
          <el-button type="primary" @click="submitForm('ruleForm')"
            >确定</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import system from "../../components/system_left.vue";
export default {
  components: {
    system,
  },
  data() {
    return {
      leftList: this.Plugins.operateData(),
      ruleForm: {
        name: "",
      },
      tableData: [],
      page: 1,
      pageSize: 10,
      total: 0,
      dialogFormVisible: false,
      title: "",
      editId: "",
      ruleForm1: {
        sort: "",
        name: "",
      },
      rules: {
        sort: [{ required: true, message: "必选项", trigger: "blur" }],
        name: [{ required: true, message: "必选项", trigger: "blur" }],
      },
      selectData: {},
      active: 0, // 0: 保安白名单, 1: 客户白名单
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    selectTab(val) {
      this.active = val;
      this.page = 1;
      this.getList();
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let param = {
            phone: this.ruleForm1.name,
            type: this.active == 0 ? 2 : 1,
            sort: this.ruleForm1.sort,
          };
          if (this.editId == "") {
            this.$axios
              .post(`/admapi/whitelist/add`, param)
              .then(({ data }) => {
                this.$message({
                  message: "添加成功",
                  type: "success",
                });
                this.getList();
              })
              .catch()
              .finally(() => {
                this.dialogFormVisible = false;
                this.ruleForm1.sort = "";
                this.ruleForm1.name = "";
              });
          } else {
            param.id = this.editId;
            this.$axios
              .post(`/admapi/whitelist/update`, param)
              .then(({ data }) => {
                this.$message({
                  message: "编辑成功",
                  type: "success",
                });
                this.getList();
              })
              .catch()
              .finally(() => {
                this.dialogFormVisible = false;
                this.ruleForm1.sort = "";
                this.ruleForm1.name = "";
              });
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm1(formName) {
      this.$refs[formName].resetFields();
      this.dialogFormVisible = false;
    },
    handleEdit(val) {
      this.selectData = val;
      this.editId = val.id;
      this.title = "编辑白名单";
      this.ruleForm1.sort = val.sort;
      this.ruleForm1.name = val.propValue;
      this.dialogFormVisible = true;
    },
    add() {
      this.title = "添加白名单";
      this.dialogFormVisible = true;
      this.editId = "";
    },
    resetForm() {
      this.ruleForm.name = "";
      this.getList();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getList();
    },
    getList() {
      let param = {
        page: this.page,
        pageSize: this.pageSize,
        queryParams: [],
        searchKey: "",
      };
      let url = "";
      if (this.active == 0) {
        url = `/admapi/whitelist/bodyguardlist`;
      } else {
        url = `/admapi/whitelist/customlist`;
      }
      if (this.ruleForm.name != "") {
        param.queryParams.push({
          name: "prop_value",
          type: "select",
          values: [
            {
              itemKey: this.ruleForm.name,
            },
          ],
        });
      }
      this.$axios
        .post(url, param)
        .then(({ data }) => {
          this.tableData = data.items;
          this.total = data.page.totalRows;
        })
        .catch()
        .finally();
    },
    deleteItem(val) {
      this.$confirm("是否删除", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let url = "";
          if (this.active == 0) {
            url = `/admapi/whitelist/bodyguarddel`;
          } else {
            url = `/admapi/whitelist/customdel`;
          }
          this.$axios
            .post(`${url}/${val.id}`)
            .then(({ data }) => {
              this.$message({
                message: "删除成功",
                type: "success",
              });
              this.getList();
            })
            .catch()
            .finally();
        })
        .catch(() => {});
    },
  },
};
</script>
<style scoped>
.pageTitle1 {
  cursor: pointer;
  font-size: 16px;
}
.active {
  color: #409eff;
  font-weight: 600;
}
/* /deep/ .el-form-item__label {
  width: 70px !important;
} */
</style>
